// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import applicationReducer from './slices/applicationSlice';
import underwriterReducer from './slices/underwriterSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    application: applicationReducer,
    underwriter: underwriterReducer
  }
});

export default store;
